import React from "react";

const Achievements = ({ data }) => {
  return (
    <div className=" wow zoomIn">
      <p dangerouslySetInnerHTML={{ __html: data }}></p>
    </div>
  );
};

export default Achievements;
